<template>
  <el-select
    :disabled="distinct"
    :value="puid"
    @change="handleChange"
    :required="!distinct"
    :placeholder="$t('purchase_orders.addNewBatchUnder')"
    value-key="puid">
    <el-option
      v-for="productPuid in filterProductsInventory"
      :key="productPuid.puid"
      :label="productPuid.extendedName"
      :value="productPuid.puid">
    </el-option>
  </el-select>
</template>
<script>


export default {
  name: 'products-inventory-options',
	props: {
    distinct: {
      type: Boolean,
      default: false,
    },
    productsInventory: {
      type: Array
    },
    genericPuid : {
      type: String,
      default: null,
    },
    puid: {
      type: String,
      default: null
    }
	},
  data() {
    return {

    };
  },components: {

  },
	methods: {
    handleChange(v) {
      this.$emit('change', v);
    }
	},
	computed: {
    filterProductsInventory () {
      return _.filter(this.productsInventory, p => p.puid !== this.genericPuid);
    }
	},
}
</script>
<style lang="scss" scoped>




</style>
